import React from "react";

export function handleKeyDown<T extends Element>(
  e: React.KeyboardEvent<T>,
  handler: () => void,
  keys: string[] = ["Enter", " "]
): void {
  if (keys.includes(e.key)) {
    e.preventDefault();
    e.stopPropagation();
    handler();
  }
}
